<template>
  <main class="hello page fill login">
    <form class="form-signin text-center mt-3">
      <img src="/img/logo_histovery.png" alt="Logo Histovery" style="max-width: 80%" />
      <h1 class="h3 mt-4 mb-3 font-weight-normal title-font">{{ $t('dashboard_access') }}</h1>

      <!-- LANGUAGE SELECTION -->
      <div style="position: absolute; top: 2em; right: 1.5em" v-if="!isSmartphoneDevice">
        <div class="col lg-2">
          <select
            class="form-control"
            v-model="selectedLanguage"
            @change="onLanguageChange(selectedLanguage)"
          >
            <option value="fr">&#x1F1EB;&#x1F1F7;</option>
            <option value="en">&#x1F1EC;&#x1F1E7;</option>
          </select>
        </div>
      </div>

      <div style="position: absolute; right: 1em; bottom: 4em" v-if="!isCheckingCredentials">
        <label style="font-size: small"
          >{{ $t('login.or') }}&nbsp;<a
            href="#"
            data-toggle="modal"
            data-target="#customSigninModal"
            >{{ $t('login.custom').toLowerCase() }}</a
          ></label
        >
      </div>

      <div v-if="!isCheckingCredentials">
        <!-- GOOGLE SIGN IN -->
        <br />
        <button
          id="googleSigninButton"
          class="btn btn-lg btn-chart btn-block"
          type="button"
          @click="googleSignIn"
        >
          {{ $t('sign_in_google') }}
        </button>

        <div v-if="loginError" class="alert alert-danger mt-2" role="alert">
          {{ $t('message.error.login') }}
        </div>
      </div>
      <div v-if="isCheckingCredentials">
        <label>{{ $t('logging_in') }}</label>
        <div class="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div>
        <p class="mt-5 mb-3">&copy; 2013-{{ year }} Histovery</p>
      </div>
    </form>

    <!-- CUSTOM SIGN IN MODAL -->
    <div
      class="modal fade"
      id="customSigninModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="customSigninModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="customSigninModalLabel">{{ $t('login.custom') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form-signin text-center">
              <label for="inputEmail" class="sr-only">{{ $t('login.email') }}</label>
              <input
                v-model="signInForm.email"
                type="email"
                id="inputEmail"
                :class="emptyEmail ? 'form-control is-invalid' : 'form-control'"
                :placeholder="$t('login.email')"
                required
                autofocus
              />
              <div v-if="emptyEmail" class="invalid-feedback">
                {{ $t('message.error.email_missing') }}
              </div>
              <label for="inputPassword" class="sr-only">{{ $t('login.password') }}</label>
              <input
                v-model="signInForm.password"
                type="password"
                id="inputPassword"
                :class="emptyPassword ? 'form-control is-invalid' : 'form-control'"
                :placeholder="$t('login.password')"
                required
                @keyup.enter="customSignIn"
              />
              <div v-if="emptyPassword" class="invalid-feedback">
                {{ $t('message.error.password_missing') }}
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="customSignIn"
            >
              {{ $t('sign_in') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
// import { initSession } from '../utils/SessionManager'
import { utilsMixin } from '../utils/mixins'

import configChartHierarchy from '../assets/config/dashboardChartHierarchy'

import axios from 'axios'

export default {
  name: 'Login',
  dependencies: ['loginService', 'dashboardService', 'adminService'],
  mixins: [utilsMixin],
  data() {
    return {
      signInForm: {
        email: '',
        password: '',
      },
      selectedLanguage: 'fr',
      emptyEmail: false,
      emptyPassword: false,
      loginError: false,
      isCheckingCredentials: false,
      year: moment().format('YYYY'),
    }
  },
  async mounted() {
    this.selectedLanguage = this.$store.getters['prefs/language']

    if (!this.selectedLanguage) {
      var locale = navigator.language.split('-')[0]
      if (locale != 'fr' && locale != 'en') {
        locale = 'en'
      }
      this.onLanguageChange(locale)
    }

    //If user is authenticated by google 0auth2
    if (
      this.$route.query.access_token &&
      this.$route.query.email &&
      this.$route.query.refresh_token &&
      this.$route.query.expiry_date
    ) {
      this.isCheckingCredentials = true
      await this.checkLoginCredentials()
    } else {
      this.isCheckingCredentials = false
      if (this.$route.query.error) {
        this.loginError = true
      }
    }
  },
  methods: {
    googleSignIn: async function() {
      try {
        const data = await this.loginService.signin()
        const authUrl = data.authUrl
        if (authUrl) {
          window.location = authUrl
        } else {
          throw Error('No google redirection URL found')
        }
      } catch (error) {
        console.error('Error when retrieving google authorization URL', error)
        this.loginError = true
        await this.$store.dispatch('auth/removeCurrentUser')
        this.$router.push('/login')
      }
    },
    checkLoginCredentials: async function() {
      try {
        this.isCheckingCredentials = true
        let credentials = {
          access_token: this.$route.query.access_token,
          refresh_token: this.$route.query.refresh_token,
          expiry_date: this.$route.query.expiry_date,
        }
        let currentUserEmail = this.$route.query.email

        window.history.replaceState(null, '', '/login')

        //Check user's credentials
        const loggedUser = await this.userCheck(currentUserEmail, credentials)
        this.$log.debug('loggedUser', loggedUser)

        const matchs = loggedUser.tabs.filter(tab => {
          return tab.dashboards && tab.dashboards.length > 0
        })

        //Init user session
        // await initSession()

        //If saved route when user logout by system
        if (localStorage.getItem('savedRoute')) {
          this.$router.push(localStorage.getItem('savedRoute'))
        } else {
          this.$router.push(`/dashboard/${matchs[0].dashboards[0].id}`)
        }
      } catch (error) {
        console.error('Error when checkLoginCredentials:', error)
        this.loginError = true
        await this.$store.dispatch('auth/removeCurrentUser')
        this.isCheckingCredentials = false
      }
    },
    customSignIn: async function() {
      try {
        this.isCheckingCredentials = true

        this.emptyEmail = String(this.signInForm.email).trim() == ''
        this.emptyPassword = String(this.signInForm.password).trim() == ''

        if (this.emptyEmail || this.emptyPassword) {
          throw Error('Login informations are empty')
        }

        const data = await this.loginService.signinUser(this.signInForm)

        if (data.api_access_token && data.result) {
          const credentials = {
            api_access_token: data.api_access_token,
          }

          let user = data.result

          const loggedUser = await this.userCheck(user.email, credentials)

          //$('#customSigninModal').modal('hide')

          if (loggedUser.tabs && loggedUser.tabs.length > 0) {
            //There is a saved route if user has been disconnected?
            if (localStorage.getItem('savedRoute')) {
              this.$router.push(localStorage.getItem('savedRoute'))
            } else {
              //We display the first dashboard of the first tab
              loggedUser.tabs.sort((a, b) => {
                return a.rank - b.rank
              })

              for (const tab of loggedUser.tabs) {
                if (tab.dashboards && tab.dashboards.length > 0) {
                  this.$router.push(`/dashboard/${tab.dashboards[0].id}`)
                  break
                }
              }
            }
          } else {
            throw Error('No tabs or dashboards found for this user')
          }
        }
      } catch (error) {
        this.isCheckingCredentials = false
        console.error('Error customSignIn:', error)
        this.loginError = true
        await this.$store.dispatch('auth/removeCurrentUser')
        this.$router.push('/login')
      }
    },
    async userCheck(email, credentials) {
      try {
        const accessTokenData = await this.loginService.getUserAccessToken(email)
        if (accessTokenData.result.email === email) {
          //Updating and saving credentials
          credentials['api_access_token'] = accessTokenData.result.access_token
          credentials['api_refresh_token'] = accessTokenData.result.refresh_token
          credentials['api_expiry_time'] = accessTokenData.result.expiry_time
          await this.$store.dispatch('auth/setCurrentCredentials', credentials)

          //Getting user from database
          let loggedUser = await this.loginService.getUser(email)

          await this.$store.dispatch('auth/setCurrentUser', loggedUser)

          this.$session.start()
          this.$session.set('user', loggedUser)
          this.$session.set('credentials', credentials)

          loggedUser.tabs.sort((a, b) => {
            return a.rank - b.rank
          })

          const matchs = loggedUser.tabs.filter(tab => {
            return tab.dashboards && tab.dashboards.length > 0
          })

          //If user has tabs and dashboards already set
          if (loggedUser.tabs.length > 0 && matchs.length > 0 && matchs[0].dashboards.length > 0) {
            await this.initConfigFiles(loggedUser)
            return loggedUser
          } else {
            //New user, init his tabs and dashboards
            const data = await this.dashboardService.initDashboard({
              user_id: loggedUser.id,
            })
            loggedUser = data.result
            await this.$store.dispatch('auth/setCurrentUser', loggedUser)
            await this.initConfigFiles(loggedUser)
            return loggedUser
          }
        } else {
          throw Error('Email mistmatch', email, accessTokenData.result.email)
        }
      } catch (error) {
        console.error('Error when checking user:', error)
        throw error
      }
    },
    initConfigFiles: async function(user) {
      try {
        Vue.prototype.$startDate = moment(new Date(), 'YYYY-MM-DD').subtract(1, 'month')
        Vue.prototype.$endDate = moment(new Date(), 'YYYY-MM-DD')

        //Saved charts configuration files for logged user
        await this.$store.dispatch('config/removeCurrentConfig')

        const chartsConfig = configChartHierarchy[user.role.toLowerCase()]
        await this.$store.dispatch('config/setCurrentChartsConfig', chartsConfig)

        //Get filters config hierarchy from data
        const response = await axios.get(`${this.$baseURL}/config/filters`)
        let filters = response.data.result

        //Update available filters and filters values according to logged user's role
        if (user.userRole.name === 'partner') {
          filters.filter_values.site_location = Array.from(user.sites, site => {
            return site.site
          })

          let customFilters = filters.custom
          let updatedCustomFilters = {}

          for (const key in customFilters) {
            if (filters.filter_values.site_location.indexOf(key) > -1) {
              updatedCustomFilters[key] = customFilters[key]
            }
          }
          filters.custom = updatedCustomFilters
        }

        await this.$store.dispatch('config/setCurrentFiltersConfig', filters)
      } catch (error) {
        console.error('Error when config files initialization:', error)
        throw error
      }
    },
    onLanguageChange: function(locale) {
      this.$locale = locale
      this.$store.dispatch('prefs/setCurrentLanguage', locale)
    },
    displayLoginForm: function() {},
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
